import tour from "@/features/tour/tourService";

/**
 * Mixin de tour para DIÁLOGOS (v-dialog).
 *
 * Diferente do tourMixin de páginas: um diálogo é montado escondido, então o
 * tour NÃO pode disparar no mounted. A regra aqui é:
 *   - O diálogo chama tourOnOpen() quando ABRE (auto-inicia só na 1ª vez).
 *   - startTour() reabre o tour a qualquer momento (botão "?" DENTRO do diálogo,
 *     pois o overlay do driver.js fica acima do modal, mas o FAB global não).
 *
 * O componente deve definir:
 *   tourId       -> String
 *   tourSteps()  -> [{ anchor, title, description }]
 *   (opcional) tourReady() -> Boolean  (espera conteúdo assíncrono do diálogo)
 */
export default {
  data() {
    return { _tourTimer: null, _tourTries: 0 };
  },

  beforeDestroy() {
    clearTimeout(this._tourTimer);
  },

  methods: {
    /** Chamar quando o diálogo abre (auto-inicia só na primeira vez). */
    tourOnOpen() {
      this._tourKick(/* auto */ true);
    },

    /** Botão "?" dentro do diálogo — replay manual. */
    startTour() {
      this._tourKick(/* auto */ false);
    },

    _tourKick(auto) {
      if (!this.tourId || typeof this.tourSteps !== "function") return;
      this._tourTries = 0;
      // Deixa o v-dialog renderizar o conteúdo antes de procurar as âncoras.
      this.$nextTick(() => this._tourWaitAndStart(auto));
    },

    _tourWaitAndStart(auto) {
      clearTimeout(this._tourTimer);
      const steps = this.tourSteps() || [];
      const ready =
        typeof this.tourReady === "function" ? this.tourReady() : true;
      const hasAnchor = steps.some(
        (s) => !s.anchor || document.querySelector(`[data-tour="${s.anchor}"]`),
      );

      if (ready && hasAnchor) {
        if (auto) tour.maybeAutoStart(this.tourId, steps);
        else tour.start(this.tourId, steps);
        this._tourTries = 0;
        return;
      }
      if (this._tourTries < 20) {
        this._tourTries += 1;
        this._tourTimer = setTimeout(() => this._tourWaitAndStart(auto), 300);
      }
    },
  },
};
